// extracted by mini-css-extract-plugin
export default {"wrap":"fwn87YLhBdES7_qZXJa8","header":"PojrMOJj_yXMx_GUacNs","details":"zQcyc73dSEHXaXxe8FuB"};